import React, { useRef, useMemo, useContext, FC } from "react"
import Styles from "../styles/LocalFile.module.scss"
import clsx from "clsx"
import { VideoTrimModal } from "./VideoTrim"
import { ModalContext } from "../context/ModalContext"
import ffmpeg from "../utils/FFmpeg"
import { ToastContext } from "../context/ToastContext"
import { CloseIcon } from "../icons/CloseIcon"
import { CutIcon } from "../icons/CutIcon"

type Props = {
    file: File,
    getVideoDuration: ( duration: number ) => void
    removeFile?: () => void,
    trimmedVideo: Blob | null,
    setTrimmedVideo: ( file: Blob | null ) => void
    videoTrimEnabled?: boolean
}

const LocalFile: FC<Props> = ( {
    file,
    getVideoDuration,
    removeFile,
    trimmedVideo,
    setTrimmedVideo,
    videoTrimEnabled = true
} ) => {

    const {
        modalVisible: trimVideoModalVisible,
        setModalVisible: setTrimVideoModalVisible,
        setModalContent
    } = useContext( ModalContext )
    const { addToast } = useContext( ToastContext )
    const localVideo = useRef<HTMLVideoElement>( null )

    const ImageMemo = useMemo( () =>
        <img
            src={ window.URL.createObjectURL( file ) }
            className={ Styles.image }
            alt="" />
        , [ file ] )

    const VideoMemo = useMemo( () =>
        <video
            ref={ localVideo }
            className={ Styles.video }
            muted={ true }
            src={ URL.createObjectURL( trimmedVideo || file ) }
            onLoadedData={ () => {
                if ( !localVideo.current ) return
                getVideoDuration( localVideo.current.duration )
                localVideo.current.play()
                setTimeout( () => {
                    localVideo.current && localVideo.current.pause()
                }, 50 )
            } }
            controls>
        </video>, [ file, trimmedVideo ] )

    const renderFile = () => {
        if ( file.type.includes( "image" ) ) return ImageMemo
        else if ( file.type.includes( "video" ) ) return VideoMemo
    }

    const trimVideo = () => {
        if ( !ffmpeg.getCanUseFFmpeg() ) {
            addToast( {
                type: "warn",
                position: 'center',
                text: "動画のトリミングはPCの Google Chrome でのみお使いいただけます",
                duration: 6000
            } )
            return
        }
        // addToast( {
        //     type: "warn",
        //     position: 'center',
        //     text: "Web版での動画のトリミングはテスト中の機能です。\n動画の最初がうまく切り取れない場合があります。\nプレビューでご確認ください",
        //     duration: 8000
        // } )
        setTrimVideoModalVisible( true )
        setModalContent(
            () => <VideoTrimModal
                visible={ true }
                closeModal={ () => setTrimVideoModalVisible( false ) }
                setTrimmedVideo={ setTrimmedVideo }
                file={ file } /> )
    }

    return (
        <div className={ Styles.container } >
            { renderFile() }
            {removeFile &&
                <div
                    className={ clsx( Styles.icon_container, Styles.remove_file_icon_container ) }
                    onClick={ removeFile }>
                    <CloseIcon
                        className={ Styles.remove_file_icon } />
                </div> }
            { file.type.includes( "video" ) && videoTrimEnabled &&
                <div
                    className={ clsx( Styles.icon_container, Styles.trim_video_icon_container ) }
                    onClick={ trimVideo }>
                    <CutIcon
                        className={ Styles.trim_video_icon } />
                </div> }
        </div>
    )
}

export default LocalFile
